import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { AgeGate } from "@/components/AgeGate";
import { router } from "@/router";
import { usePreferences } from "@/store/preferences";
import { disableAnalytics, initAnalytics } from "@/analytics/analytics";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  const { analyticsOptOut } = usePreferences();

  useEffect(() => {
    initAnalytics({ enabled: !analyticsOptOut, respectDnt: true });
    if (analyticsOptOut) disableAnalytics();
  }, [analyticsOptOut]);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AgeGate>
          <RouterProvider router={router} />
        </AgeGate>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
